export const initialState = {
  columns: [
    {
      id: 'name',
      numeric: false,
      disablePadding: true,
      label: 'Name',
      align: 'left',
    },
    {
      id: 'content_type',
      numeric: false,
      disablePadding: true,
      label: 'Type',
      align: 'left',
    },
    {
      id: 'last_modified',
      numeric: false,
      disablePadding: true,
      label: 'Last modified',
      align: 'center',
    },
  ],
  items: {
    offset: 0,
    loading: true,
    loadingNext: false,
    hasMore: false,
    value: [],
  },
  selectedFile: {},
  selectedFiles: [],
  recentlyUploadedFile: {},
  tree: [],
  folderTree: {
    loading: false,
    value: [],
  },
  flattenFolderTree: [],
  shared: {
    loading: true,
    value: [],
  },
  shareList: {
    loading: false,
    value: [],
  },
  fileForm: {
    loading: false,
  },
  shareableAccounts: {
    loading: false,
    value: [],
  },
  importedFiles: [],
  movingFiles: [],
  sharedBuckets: [],
  activeFolder: null,
};
